<template>
    <div class="error-indicator">
        <span>We can encountered an error loading this page, please try again.</span>
    </div>
</template>

<script>

export default {
    data() {
        return {}
    },
}
</script>
